import createInstance from "./instance";
import enrollment from "./enrollment";
import field from "./enrollment/field";

const enrollmentsSvcLambda = {
  createInstance,
  getEnrollments: enrollment.GET,
  /**
   * @deprecated Use getEnrollments instead
   */
  getEnrollmentsNonLambda: enrollment.nonLambda.GET,
  getFieldEnrollments: field.GET,
  enrollFields: field.POST,
};

export default enrollmentsSvcLambda;

export * from "./instance";
export * from "./schemas";
